<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">{{ titolo }}</h2>
            </v-col>
            <v-col cols="12" sm="4" md="3">
                <v-text-field v-model="ricerca" label="Cerca" density="compact" variant="outlined" hide-details
                    clearable prepend-inner-icon="mdi-magnify" @update:model-value="ricercaCambiata" />
            </v-col>
            <v-col v-for="f in filtri" :key="f.key" cols="6" sm="3" md="2">
                <v-select v-model="valoriFiltro[f.key]" :items="itemsFiltro(f)" :item-title="f.titleKey || 'title'"
                    :item-value="f.valueKey || 'value'" :label="f.label" density="compact" variant="outlined"
                    hide-details clearable @update:model-value="carica" />
            </v-col>
            <v-spacer />
            <v-col v-if="puoScrivere && importabile" cols="auto">
                <v-btn variant="tonal" prepend-icon="mdi-file-upload-outline" @click="apriImport">Importa CSV</v-btn>
            </v-col>
            <v-col v-if="puoScrivere" cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">{{ nuovoLabel }}</v-btn>
            </v-col>
        </v-row>

        <v-alert v-if="limite && lista.length >= limite" type="info" variant="tonal" density="compact" class="mb-2">
            Mostrati i primi {{ limite }} risultati: usa la ricerca o i filtri per restringere l'elenco.
        </v-alert>

        <v-data-table :headers="headersCompleti" :items="lista" :items-per-page="15" density="comfortable">
            <template v-for="c in colonne" #[`item.${c.key}`]="{ item }" :key="c.key">
                {{ formattaCella(item[c.key], c) }}
            </template>
            <template #[`item.azioni`]="{ item }">
                <v-btn v-if="puoScrivere" icon variant="text" size="small" @click="apriDialog(item)"
                    title="Modifica">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if="puoScrivere" icon variant="text" size="small" color="error"
                    @click="daEliminare = item" title="Elimina">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="720" :fullscreen="isMobile">
            <v-card>
                <v-card-title>{{ form.id ? 'Modifica' : nuovoLabel }}</v-card-title>
                <v-card-text>
                    <v-form ref="formRef">
                        <v-row dense>
                            <v-col v-for="f in campi" :key="f.key" cols="12" :sm="f.cols || 6">
                                <v-select v-if="f.tipo === 'select'" v-model="form[f.key]" :items="f.items"
                                    :label="f.label" :clearable="!f.required" :rules="regole(f)" />
                                <v-select v-else-if="f.tipo === 'lookup'" v-model="form[f.key]"
                                    :items="lookupItems[f.key] || []" :item-title="f.lookup.title"
                                    :item-value="f.lookup.value" :label="f.label" :clearable="!f.required"
                                    :rules="regole(f)" />
                                <v-text-field v-else-if="f.tipo === 'number'" v-model="form[f.key]" type="number"
                                    :step="f.step || 'any'" :label="f.label" :hint="f.hint"
                                    :persistent-hint="!!f.hint" :rules="regole(f)" />
                                <v-text-field v-else-if="f.tipo === 'date'" v-model="form[f.key]" type="date"
                                    :label="f.label" :rules="regole(f)" />
                                <v-text-field v-else v-model="form[f.key]" :label="f.label" :hint="f.hint"
                                    :persistent-hint="!!f.hint" :rules="regole(f)" />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialog = false">Annulla</v-btn>
                    <v-btn color="primary" :loading="salvando" @click="salva">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog :model-value="!!daEliminare" max-width="420" @update:model-value="daEliminare = null">
            <v-card>
                <v-card-title>Eliminare il record?</v-card-title>
                <v-card-text>L'operazione rimuove il record dall'elenco.</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="daEliminare = null">Annulla</v-btn>
                    <v-btn color="error" @click="elimina">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogImport" max-width="640" :fullscreen="isMobile">
            <v-card>
                <v-card-title>Importa da CSV</v-card-title>
                <v-card-text>
                    <p class="text-body-2 mb-2">
                        Il file CSV (separatore ; o , — codifica UTF-8 o Windows-1252) deve avere una riga di
                        intestazione. I record già presenti (stessa chiave) vengono aggiornati, gli altri aggiunti.
                    </p>
                    <p v-if="colonneImport" class="text-caption text-medium-emphasis mb-3">
                        Colonne riconosciute: {{ colonneImport }}
                    </p>
                    <v-file-input v-model="fileImport" label="File CSV" accept=".csv,.txt" density="compact"
                        variant="outlined" prepend-icon="mdi-file-delimited-outline" />
                    <v-alert v-if="risultatoImport" :type="risultatoImport.errori.length ? 'warning' : 'success'"
                        variant="tonal" density="compact" class="mt-2">
                        Inseriti: {{ risultatoImport.inseriti }} — Aggiornati: {{ risultatoImport.aggiornati }} —
                        Scartati: {{ risultatoImport.errori.length }}
                        <ul v-if="risultatoImport.errori.length" class="mt-1 pl-4">
                            <li v-for="(e, i) in risultatoImport.errori.slice(0, 15)" :key="i">
                                Riga {{ e.riga }}: {{ e.messaggio }}
                            </li>
                            <li v-if="risultatoImport.errori.length > 15">…e altre {{ risultatoImport.errori.length - 15
                                }}</li>
                        </ul>
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogImport = false">Chiudi</v-btn>
                    <v-btn color="primary" :loading="importando" :disabled="!fileImport" @click="importa">
                        Importa
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import {
    anagrafica_lista,
    anagrafica_crea,
    anagrafica_aggiorna,
    anagrafica_elimina,
    anagrafica_importa,
} from "@/api/api.anagrafiche.js";

// Tabella con crea/modifica/elimina e import CSV per un'anagrafica piatta. Le pagine
// specifiche passano solo titolo, rotta API, colonne e campi del form.
export default {
    name: "AnagraficaCrud",

    props: {
        titolo: { type: String, required: true },
        endpoint: { type: String, required: true },
        nuovoLabel: { type: String, default: "Nuovo" },
        colonne: { type: Array, required: true },
        campi: { type: Array, required: true },
        // [{ key, label, items: [...] }] oppure con lookup: { key, label, lookup: { endpoint, title, value } }
        filtri: { type: Array, default: () => [] },
        puoScrivere: { type: Boolean, default: false },
        importabile: { type: Boolean, default: true },
        colonneImport: { type: String, default: "" },
        // Se valorizzato, avvisa quando l'elenco raggiunge il limite del server.
        limite: { type: Number, default: 0 },
    },

    data() {
        return {
            lista: [],
            ricerca: "",
            timerRicerca: null,
            valoriFiltro: {},
            lookupItems: {},
            dialog: false,
            salvando: false,
            form: {},
            daEliminare: null,
            dialogImport: false,
            fileImport: null,
            importando: false,
            risultatoImport: null,
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        headersCompleti() {
            const headers = this.colonne.map((c) => ({ title: c.title, key: c.key }));
            if (this.puoScrivere) headers.push({ title: "", key: "azioni", sortable: false });
            return headers;
        },
    },

    mounted() {
        this.caricaLookup();
        this.carica();
    },

    methods: {
        itemsFiltro(f) {
            return f.lookup ? this.lookupItems[f.key] || [] : f.items || [];
        },

        async caricaLookup() {
            const fonti = [...this.campi, ...this.filtri].filter((x) => x.lookup);
            for (const f of fonti) {
                try {
                    const resp = await anagrafica_lista(f.lookup.endpoint);
                    this.lookupItems = { ...this.lookupItems, [f.key]: resp.data };
                } catch (error) {
                    console.log(error);
                }
            }
        },

        async carica() {
            const params = {};
            if (this.ricerca) params.search = this.ricerca;
            for (const [k, v] of Object.entries(this.valoriFiltro)) {
                if (v !== null && v !== undefined && v !== "") params[k] = v;
            }
            try {
                const resp = await anagrafica_lista(this.endpoint, params);
                this.lista = resp.data;
            } catch (error) {
                console.log(error);
            }
        },

        ricercaCambiata() {
            clearTimeout(this.timerRicerca);
            this.timerRicerca = setTimeout(this.carica, 300);
        },

        formattaCella(valore, colonna) {
            if (valore === null || valore === undefined || valore === "") return "";
            if (colonna.tipo === "date") return String(valore).substring(0, 10);
            return valore;
        },

        regole(f) {
            const r = [];
            if (f.required) r.push((v) => (v !== null && v !== undefined && v !== "") || "Obbligatorio");
            return r;
        },

        formVuoto() {
            const form = { id: null };
            for (const f of this.campi) form[f.key] = f.default !== undefined ? f.default : null;
            return form;
        },

        apriDialog(item) {
            if (item) {
                const form = { id: item.id };
                for (const f of this.campi) {
                    const v = item[f.key];
                    form[f.key] = f.tipo === "date" && v ? String(v).substring(0, 10) : v;
                }
                this.form = form;
            } else {
                this.form = this.formVuoto();
            }
            this.dialog = true;
        },

        // I campi numerici vuoti diventano null, gli altri testi vuoti restano stringa vuota.
        payload() {
            const dati = {};
            for (const f of this.campi) {
                let v = this.form[f.key];
                if (f.tipo === "number") v = v === "" || v === null || v === undefined ? null : Number(v);
                if (f.tipo === "date" && !v) v = null;
                dati[f.key] = v;
            }
            return dati;
        },

        async salva() {
            const { valid } = await this.$refs.formRef.validate();
            if (!valid) return;
            this.salvando = true;
            try {
                const dati = this.payload();
                if (this.form.id) {
                    await anagrafica_aggiorna(this.endpoint, this.form.id, dati);
                } else {
                    await anagrafica_crea(this.endpoint, dati);
                }
                this.dialog = false;
                await this.carica();
            } catch (error) {
                console.log(error);
            }
            this.salvando = false;
        },

        async elimina() {
            const item = this.daEliminare;
            this.daEliminare = null;
            if (!item) return;
            try {
                await anagrafica_elimina(this.endpoint, item.id);
                await this.carica();
            } catch (error) {
                console.log(error);
            }
        },

        apriImport() {
            this.fileImport = null;
            this.risultatoImport = null;
            this.dialogImport = true;
        },

        async importa() {
            const file = Array.isArray(this.fileImport) ? this.fileImport[0] : this.fileImport;
            if (!file) return;
            this.importando = true;
            this.risultatoImport = null;
            try {
                const resp = await anagrafica_importa(this.endpoint, file);
                this.risultatoImport = resp.data;
                await this.carica();
            } catch (error) {
                console.log(error);
            }
            this.importando = false;
        },
    },
};
</script>
